import Button from '../../button/block';
import style from './style.module.scss';

export const HomeTile = ({ imageUrl, name, link }) => {
    const title = name.replace(' ', '<br/>');

    return (
        <div className={style.block}>
            <a href={link} className={style.link}>
                <div className={style.imgContainer}>
                    {imageUrl && <img className={style.image} src={imageUrl} alt={name} />}
                </div>

                <div className={style.content}>
                    <h3 className={style.name} dangerouslySetInnerHTML={{ __html: title }} />

                    <Button
                        Wrapper="span"
                        text="VOIR LA FICHE"
                        aspect="contained"
                        backgroundContained={style.green}
                        colorContained={style.blue}
                        inspector={false}
                        classNames={style.button}
                    />
                </div>
            </a>
        </div>
    );
};
